// Central configuration for the frontend.
//
// API_BASE_URL is the single source of truth for the backend base URL.
// It can be overridden at build time via the REACT_APP_API_URL environment
// variable (e.g. http://localhost:8000 for local development, or the
// production host in the Docker build env). When unset, it falls back to the
// current production backend so existing builds keep working unchanged.
//
// Consumers should import this and build endpoints as `${API_BASE_URL}/...`
// instead of hardcoding the host. No trailing slash.
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://margix-api.orka-group.eu";
